import Lenis from 'lenis';

let lenis;

const init = async () => {
lenis = new Lenis({
       duration: 1.8,
       easing: (t) => 1 - Math.pow(1 - t, 3), // easeOutCubic - smoother deceleration
       lerp: 0.1, // smooth interpolation (0.1 = smooth, 1 = instant)
       smooth: true,
       direction: 'vertical',
       gestureDirection: 'vertical',
       smoothTouch: false,
       infinite: false,
});
     
function raf(time) {
       lenis.raf(time);
       requestAnimationFrame(raf);
}
     
requestAnimationFrame(raf);

lenis.on('scroll', (e) => {        
       scrollUpdates(e);
})

// Smooth scroll for # links, but skip special ones like #login
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    const targetId = link.getAttribute('href');

    // skip if hash is used for modal or JS triggers
    const skipHashes = ['#login', '#register', '#cart']; // add more if needed
    if (skipHashes.includes(targetId)) return;

    if (targetId && targetId.length > 1) {
      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        e.preventDefault();
        lenis.scrollTo(targetEl, { offset: -20 });
      }
    }
  });
});



let body = document.querySelector('body');
var lastDir = 'down';
function scrollUpdates(e) {
       var progressTop = e.actualScroll;
       var direction = e.direction;    
   
     if (progressTop > 250) {
       if (!body.classList.contains("short-header")) {
         body.classList.add("short-header");
       }
     } else {
       if (body.classList.contains("short-header")) {
         body.classList.remove("short-header");
       }
     }
   
     if (lastDir === 'up') {
       if (!body.classList.contains("scrollingtop")) {
         body.classList.add("scrollingtop");
       }
     } else {
       if (body.classList.contains("scrollingtop")) {
         body.classList.remove("scrollingtop");
       }
     }
     if (direction === -1) {
       lastDir = 'up';
     } 
     if (direction === 1) {
       lastDir = 'down';
     }    
}
}

export { init, lenis };

export function smoothPause(value) {
  if(value==true) {
    lenis.stop();
  } else {
    lenis.start();
  }
}

export function smoothGoTo(value, bool) {
    lenis.scrollTo(value);
}

export function smoothmove() {
  jQuery(".go-to-element").on("click", function (e) {
    var moveto = jQuery(this).data("moveto");
    lenis.scrollTo(moveto);
  });
}

export function smoothkiller() {
  //console.log("smoothkiller");
  lenis.destroy();
}

export function smoothloc() {
  lenis.scrollTo(0);
}
export function smoothrefresh() {
    //nothing for now
}